export function getDefaultSignParams() {
  return {
    phone: '',
  };
}
